// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".official-poper{border:none!important;background:#fff!important;box-shadow:0 2px 16px 0 rgba(0,0,0,.12)!important;border-radius:0!important;padding:20px!important;transition:none!important;margin-bottom:23px}.official-poper .popper__arrow{display:block!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
